import { render, staticRenderFns } from "./HotelCardAdditional.vue?vue&type=template&id=e299f5ae&scoped=true&"
import script from "./HotelCardAdditional.vue?vue&type=script&lang=ts&"
export * from "./HotelCardAdditional.vue?vue&type=script&lang=ts&"
import style0 from "./HotelCardAdditional.vue?vue&type=style&index=0&id=e299f5ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e299f5ae",
  null
  
)

export default component.exports